/*=========================================================================================
  File Name: router.js
  Description: Routes for vue-router. Lazy loading is enabled.
  Object Strucutre:
                    path => router path
                    name => router name
                    component(lazy loading) => component to load
                    meta : {
                      rule => which user can have access (ACL)
                      breadcrumb => Add breadcrumb to specific page
                      pageTitle => Display title besides breadcrumb
                    }
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


import Vue from 'vue'
import Router from 'vue-router'
import auth from "@/auth/authService";

//import firebase from 'firebase/app'
import 'firebase/auth'

Vue.use(Router)

const router = new Router({
    mode: 'history',
    base: process.env.BASE_URL,
    scrollBehavior () {
        return { x: 0, y: 0 }
    },
    routes: [

        {
    // =============================================================================
    // MAIN LAYOUT ROUTES
    // =============================================================================
            path: '',
            component: () => import('./layouts/main/Main.vue'),
            children: [
        // =============================================================================
        // Theme Routes
        // =============================================================================
                {
                    path: '/',
                    redirect: '/home'
                },
                {
                    path: '/home',
                    name: 'home',
                    component: () => import('./views/Home.vue'),
                    meta: {
                        rule: 'admin',
                        authRequired: true,
                    }
                },
                {
                    path: '/home/:id',
                    name: 'home',
                    component: () => import('./views/Home.vue'),
                    meta: {
                        rule: 'admin',
                        authRequired: true,
                    }
                },
                {
                    path: '/hijos/',
                    name: 'hijos',
                    component: () => import('./components/Hijos.vue'),
                    meta: {
                        rule: 'admin',
                        authRequired: true,
                    }
                },
                {
                    path: '/configuracion/',
                    name: 'configuracion',
                    component: () => import('./components/Configuracion.vue'),
                    meta: {
                        rule: 'admin',
                        authRequired: true,
                    }
                },
                {
                    path: '/carrito/',
                    name: 'carrito',
                    component: () => import('./components/Carrito.vue'),
                    meta: {
                        rule: 'admin',
                        authRequired: true,
                    }
                },
                {
                    path: '/reservas/',
                    name: 'reservas',
                    component: () => import('./components/Reservas.vue'),
                    meta: {
                        rule: 'admin',
                        authRequired: true,
                    }
                },
                {
                    path: '/paygold-espera/',
                    name: 'paygold-espera',
                    component: () => import('./components/PayGoldEspera.vue'),
                    meta: {
                        rule: 'admin',
                        authRequired: true,
                    }
                },
                {
                    path: '/paygold-espera/:id',
                    name: 'paygold-espera',
                    component: () => import('./components/PayGoldEspera.vue'),
                    meta: {
                        rule: 'public',
                        authRequired: false,
                    }
                },
            ],
        },
    // =============================================================================
    // FULL PAGE LAYOUTS
    // =============================================================================
        
    {
        path: '',
        component: () => import('@/layouts/full-page/FullPage.vue'),
        children: [
    // =============================================================================
    // PAGES
    // =============================================================================
            {
                path: '/pages/login',
                name: 'page-login',
                component: () => import('@/views/pages/login/Login.vue'),
                meta: {
                    rule: 'public'
                }
            },
        ]
    }
    ],
})

router.afterEach(() => {
  // Remove initial loading
  const appLoading = document.getElementById('loading-bg')
    if (appLoading) {
        appLoading.style.display = "none";
    }
})

router.beforeEach((to, from, next) => {
  to
  from
  next
  if(to.meta.authRequired) {
    if (!(auth.isAuthenticated())) {
      router.push({ path: '/pages/login', query: { to: to.path } })
    }
  }
  return next()
  /*
  firebase.auth().onAuthStateChanged(() => {

      // get firebase current user
      const firebaseCurrentUser = firebase.auth().currentUser

      // if (
      //     to.path === "/pages/login" ||
      //     to.path === "/pages/forgot-password" ||
      //     to.path === "/pages/error-404" ||
      //     to.path === "/pages/error-500" ||
      //     to.path === "/pages/register" ||
      //     to.path === "/callback" ||
      //     to.path === "/pages/comingsoon" ||
      //     (auth.isAuthenticated() || firebaseCurrentUser)
      // ) {
      //     return next();
      // }

      // If auth required, check login. If login fails redirect to login page
      
      // Specify the current path as the customState parameter, meaning it
      // will be returned to the application after auth
      // auth.login({ target: to.path });

  });
  */

});

export default router
